var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4745 5.40801L18.5975 7.53101L7.41245 18.717L5.41945 18.982C5.20614 19.0095 4.98943 18.9804 4.79172 18.8973C4.59402 18.8143 4.42411 18.6805 4.30189 18.5094C4.17967 18.3384 4.10976 18.1362 4.099 17.9269C4.08823 17.7176 4.13706 17.5098 4.23945 17.328L4.32245 17.172L5.28745 15.012L16.4745 5.40801ZM17.5325 3.93201L18.9515 2.51301C19.1411 2.32548 19.3772 2.18975 19.6357 2.1183C19.8943 2.04685 20.1679 2.04189 20.4292 2.10384C20.6904 2.1658 20.9314 2.29259 21.1281 2.47255C21.3247 2.6525 21.4703 2.88064 21.5513 3.13422C21.6324 3.38781 21.6463 3.66116 21.5918 3.92155C21.5373 4.18194 21.4161 4.42303 21.2415 4.62001L19.6975 6.16401L17.5325 3.93201Z",
    fill: "#6860EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.3bd79e57b2cbcd95b7b036102a556c41.svg";
export { ForwardRef as ReactComponent };